import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { chatApi } from "./api";
import { ResultCard } from "./ResultCard";
import { UI, useLang } from "./lang";
import { Loading } from "./Loading";

/** Results I asked for, newest first (NEW-UX-2). */
export function Reports() {
  const { workspaceId = "" } = useParams<{ workspaceId: string }>();
  const { t } = useLang();
  const q = useQuery({ queryKey: ["chat-reports", workspaceId], queryFn: () => chatApi.reports(workspaceId), enabled: !!workspaceId ,
    // "Trying again" is true: while the server is unreachable, ask every 5 s.
    refetchInterval: (query) => (query.state.status === "error" ? 5000 : false),
  });
  if (!q.data) return <Loading q={q} />;
  const items = q.data.reports.filter((m) => m.run);
  const heading = <h1 className="pwa-page-h">{t({ en: "Reports", ar: "التقارير" })}</h1>;
  if (items.length === 0) return <div className="pwa-list">{heading}<div className="pwa-empty">{t(UI.nothingYet)}</div></div>;
  return (
    <div className="pwa-list">
      {heading}
      {items.map((m) => (
        <ResultCard key={m.id} run={m.run!} line={{ en: m.body_en, ar: m.body_ar }} workspaceId={workspaceId} askedAt={m.created_at || m.run!.created_at} />
      ))}
    </div>
  );
}
